import { Text, Box, IconCheckCircle } from "@machobear/design-system"
import { useTranslation } from "react-i18next"
import { InsightBlock } from "../insight-block"

interface Props {
  averagePrice: number
}

export const PriceOkMessage = ({ averagePrice }: Props) => {
  const { t } = useTranslation()

  return (
    <InsightBlock icon={<IconCheckCircle tone="positive" size="small" />} testId="listing-price-insight">
      <Box display="flex" flexDirection="column" justifyContent="center" style={{ height: "21px" }}>
        <Text weight="medium">{t("Your rental price is competitive")}</Text>
      </Box>
      <Text>
        {t("l.listing.view.price_ok.text", {
          defaultValue: "It matches the average rent for similar listings nearby: ${{averagePrice}}/sqft. Well done!",
          averagePrice
        })}
      </Text>
    </InsightBlock>
  )
}